import React from 'react';
import { Box } from '@mui/material';
import NavBar from '../components/navbar';
import Footer from '../components/footer';
import PageHero from '../components/PageHero';
import SectionHeader from '../components/SectionHeader';
import TeamMemberCard from '../components/TeamMemberCard';
import CtaSection from '../components/CtaSection';
import ScrollReveal from '../components/animated/ScrollReveal';
import Text from '../components/Text';
import { gradients, colors } from '../theme/designTokens';
import ravisir from '../assets/images/ravisir.png';
import sami from '../assets/images/sami.png';
import jayashree from '../assets/images/jayashree.png';
import nithya from '../assets/images/nithya.png';

const directorBio = `He has Masters in Business Administration and M.S in finance. He has been awarded Ph.D in the field of Insurance. He has over 30 years of experience in the field of Risk Consulting and Insurance. Managing the 'Liability Risk' including 'Product Recall' is his forte and he had successfully handled several large liability insurance claims. He is also a much sought after speaker and guest faculty in the field of Liability Risk Management and liability insurance. ALEgION is a product of his vision and is constantly driven to higher performance levels by his passion to deliver optimal solutions and utmost satisfaction to clients. Under his able stewardship, ALEgION had succeeded in winning 'Gold Star Award' from 'India Achievers Forum' for consistent and quality service delivery to customers.`;

const ceoBio = `Saumyadeep Datta is a seasoned Business Leader with extensive experience in Insurance, Business Development and Strategic Planning. He has successfully built and led high-performing teams while driving innovation and customer-centric growth. With expertise in Corporate and Retail Insurance, he has played a key role in expanding digital insurance solutions and creating successful business channels. His strong sales leadership, market insight and ability to build strategic partnerships have been instrumental in driving business expansion and achieving sustainable revenue growth. His strong leadership, strategic vision and commitment to excellence continue to contribute to ALEgION's growth and client success.`;

const principalOfficerBio = `She has extensive experience in the insurance industry, bringing strong expertise in Risk Management, Regulatory Compliance and Client Relationship Management. She is committed to delivering reliable insurance solutions with a customer-first approach while maintaining the highest standards of professionalism and integrity. Her focus on operational excellence, ethical practices and continuous improvement contributes to the organization's growth and reinforces its commitment to providing trusted, transparent and value-driven insurance services. She is experienced in policy administration, underwriting coordination and ensuring compliance with IRDAI regulations while maintaining seamless operational efficiency. Her dedication to process excellence and stakeholder collaboration has been instrumental in enhancing service quality and fostering long-term client trust.`;

const seniorManagerBio = `She has over 15 years of experience in the insurance industry, bringing strong expertise in Risk Management, Regulatory Compliance and Client Relationship Management. She is committed to delivering reliable insurance solutions with a customer-first approach while maintaining the highest standards of professionalism and integrity. Her focus on operational excellence, ethical practices and continuous improvement contributes to the organization's growth and reinforces its commitment to providing trusted, transparent and value-driven insurance services. She is experienced in policy administration, underwriting coordination and ensuring compliance with IRDAI regulations while maintaining seamless operational efficiency. Her dedication to process excellence and stakeholder collaboration has been instrumental in enhancing service quality and fostering long-term client trust.`;

const Leadership = () => (
  <Box sx={{ bgcolor: colors.white, overflow: 'hidden' }}>
    <NavBar />
    <PageHero
      variant="dark"
      eyebrow="Leadership"
      title="Vision. Story."
      titleHighlight="Why we exist."
      subtitle="Professional leadership with a clear purpose: help organizations withstand uncertainty through resilience engineering."
      badges={['30+ Years', 'Ph.D Leadership', 'Strategic Vision']}
    />

    <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 8, md: 10 }, background: gradients.sectionLight }}>
      <Box sx={{ maxWidth: 800, mx: 'auto', textAlign: 'center' }}>
        <ScrollReveal>
          <Text variant="eyebrow" sx={{ color: colors.slate, mb: 2, display: 'block' }}>
            The Vision
          </Text>
          <Text variant="h2" color="primary" sx={{ mb: 3 }}>
            Beyond insurance. Into resilience.
          </Text>
          <Text variant="body" color="secondary" sx={{ display: 'block' }}>
            Clients no longer buy insurance alone—they buy business continuity, operational resilience, risk intelligence, trust, and confidence. ALEgION exists to own that position: an Enterprise Resilience Advisory and Engineering firm where insurance remains critical, but never the whole story.
          </Text>
        </ScrollReveal>
      </Box>
    </Box>

    <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 6, md: 10 }, background: colors.white }}>
      <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
        <ScrollReveal>
          <SectionHeader
            eyebrow="Our Leaders"
            title="The people behind ALEgION"
            highlightWords={['ALEgION']}
            subtitle="A multidisciplinary leadership team spanning risk, strategy, operations, and client excellence."
          />
        </ScrollReveal>

        <ScrollReveal>
          <TeamMemberCard
            role="Director"
            name="Dr. N. Raveendran"
            bio={directorBio}
            image={ravisir}
            imageLeft
          />
        </ScrollReveal>
        <ScrollReveal delay={0.05}>
          <TeamMemberCard
            role="Director & Chief Operating Officer"
            name="Saumyadeep Datta"
            bio={ceoBio}
            image={sami}
          />
        </ScrollReveal>
        <ScrollReveal delay={0.05}>
          <TeamMemberCard
            role="Principal Officer"
            name="V. Jayashree"
            bio={principalOfficerBio}
            image={jayashree}
            imageLeft
          />
        </ScrollReveal>
        <ScrollReveal delay={0.05}>
          <TeamMemberCard
            role="Senior Manager"
            name="S. Nithya"
            bio={seniorManagerBio}
            image={nithya}
          />
        </ScrollReveal>
      </Box>
    </Box>

    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 8, md: 10 },
        background: gradients.sectionDark,
      }}
    >
      <Box sx={{ maxWidth: 700, mx: 'auto', textAlign: 'center' }}>
        <ScrollReveal>
          <Text variant="eyebrow" sx={{ color: colors.ochre, mb: 2, display: 'block' }}>
            Advisory Board
          </Text>
          <Text variant="h3" color="white" sx={{ mb: 2 }}>
            Expanding the circle of expertise.
          </Text>
          <Text variant="body" color="muted">
            An advisory board of domain experts across cyber, climate, healthcare, and enterprise risk is being formalized—strengthening ALEgION’s resilience engineering practice.
          </Text>
        </ScrollReveal>
      </Box>
    </Box>

    <CtaSection
      title="Lead with resilience."
      subtitle="Start a conversation with the ALEgION leadership team."
    />
    <Footer />
  </Box>
);

export default Leadership;
